import BasicGraphDetail from "./Components/BasicGraphDetail";

export default BasicGraphDetail;
